<script setup lang="ts">
import type { CmsElementSocialMedia } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementSocialMedia;
  class: any;
  style: any;
}>();

const { heading, code, js_src, js_data_feed_id, js_data_theme, js_data_open_links  } = props.content?.config ?? {}


onMounted( ()=> {
  const src = js_src?.value;
  const feedId = js_data_feed_id?.value;
  const theme = js_data_theme?.value;
  const openLinks = js_data_open_links?.value;
  const container = document.getElementById('socialMediaFeed');
  if (!src || !feedId || !container) return;

  const socialMediaFeed = document.createElement('script');
  socialMediaFeed.setAttribute('src', src);
  socialMediaFeed.setAttribute('data-feed-id', feedId);
  if (theme) socialMediaFeed.setAttribute('data-theme', theme);
  if (openLinks) socialMediaFeed.setAttribute('data-open-links-in-same-page', openLinks);
  container.appendChild(socialMediaFeed);
});

</script>
<template>
  <section class="section section-main section-about section-about--alt section--solid"  :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{ heading?.value }}</h2>
      </header><!-- /.section__head -->
      <div id="socialMediaFeed">

      </div>
      <div v-html="code?.value ?? ''"></div>
    </div><!-- /.container -->
  </section>
</template>